import useCartStore from '../context/CartStore'; // Asegúrate de usar la ruta correcta
import { toast } from 'react-hot-toast';
import { Producto } from '../types';


export const verificarYAgregarAlCarrito = (producto: Producto, cantidad: number): void => {
    const {  addToCart } = useCartStore.getState(); // Accede al estado y acciones del store
  
    try {
      addToCart({
        id: producto.id,
        titulo: producto.titulo,
        categoria: producto.categoria,
        precio: producto.precio,
        cantidad: 0, // Valor temporal, se actualizará en el store
        stock: producto.stock
      }, cantidad);
  
      toast.success(`¡${producto.titulo} agregado al carrito!`);
    } catch (error) {
      if (error instanceof Error) {
        toast.error(error.message);
      } else {
        toast.error('Error al agregar el producto al carrito');
      }
    }
  };
  


  
export const handleBuy = (producto: Producto, cantidad: number): void => {
    verificarYAgregarAlCarrito(producto, cantidad);
  };
  


  // Función para compartir en redes sociales
    export const shareOnSocialMedia = (socialMedia: string) => {
      const carrito: Producto[] = JSON.parse(localStorage.getItem('carrito') || '[]');
      const productUrl = window.location.href; // URL del producto actual
      const message = `¡Mira estos productos que tengo en mi carrito! 🛒\n\n${carrito
        .map((item) => `- ${item.titulo} (${item.cantidad} unidades)`)
        .join('\n')}\n\n${productUrl}`;
  
      const encodedMessage = encodeURIComponent(message);
  
      switch (socialMedia) {
        case 'facebook':
          window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(productUrl)}`, '_blank');
          break;
        case 'twitter':
          window.open(`https://twitter.com/intent/tweet?text=${encodedMessage}`, '_blank');
          break;
        case 'instagram':
          // Instagram no permite compartir directamente, pero puedes abrir la app o sitio web
          window.open('https://www.instagram.com/', '_blank');
          break;
        default:
          break;
      }
    };
  